var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeedbackIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9412 2.5H4.05882C2.36974 2.5 1 3.87293 1 5.56662V16.2998C1 17.9929 2.36974 19.3664 4.05882 19.3664H5.58824V24.7327C5.58824 24.929 5.66287 25.1246 5.81306 25.2752C6.11191 25.5748 6.59581 25.5751 6.89435 25.2752L13.2353 19.3664H23.9412C25.63 19.3664 27 17.9929 27 16.2995V5.56662C27 3.87293 25.63 2.5 23.9412 2.5ZM6.35294 7.09993H18.5882C19.011 7.09993 19.3529 7.44278 19.3529 7.86659C19.3529 8.29039 19.011 8.63324 18.5882 8.63324H6.35294C5.93021 8.63324 5.58824 8.29039 5.58824 7.86659C5.58824 7.44278 5.93021 7.09993 6.35294 7.09993ZM12.4706 14.7665H6.35294C5.93021 14.7665 5.58824 14.4236 5.58824 13.9998C5.58824 13.576 5.93021 13.2332 6.35294 13.2332H12.4706C12.8933 13.2332 13.2353 13.576 13.2353 13.9998C13.2353 14.4236 12.8933 14.7665 12.4706 14.7665ZM21.6471 11.6999H6.35294C5.93021 11.6999 5.58824 11.357 5.58824 10.9332C5.58824 10.5094 5.93021 10.1666 6.35294 10.1666H21.6471C22.0698 10.1666 22.4118 10.5094 22.4118 10.9332C22.4118 11.357 22.0698 11.6999 21.6471 11.6999Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackIcon);
export default __webpack_public_path__ + "static/media/feedback_icon.3a9325800e04faee50822d774d0ff4ee.svg";
export { ForwardRef as ReactComponent };